import { render, staticRenderFns } from "./Imjoy.vue?vue&type=template&id=bb3a08a6&scoped=true&"
import script from "./Imjoy.vue?vue&type=script&lang=js&"
export * from "./Imjoy.vue?vue&type=script&lang=js&"
import style0 from "./Imjoy.vue?vue&type=style&index=0&id=bb3a08a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3a08a6",
  null
  
)

export default component.exports